import { IHighschoolsState } from '../../models';

export const highschoolsState: IHighschoolsState = {
  highschools: [],
};
